import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import MortgageProduct from './pages/MortgageProduct';
import SavingsProduct from './pages/SavingsProduct';
import About from './pages/About';
import Careers from './pages/Careers';
import Insights from './pages/Insights';
import InsightArticle from './pages/InsightArticle';
import Webinars from './pages/Webinars';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import Analytics from './components/Analytics';
import SeoDefaults from './components/SeoDefaults';

function App() {
  return (
    <>
      <Analytics />
      <SeoDefaults />
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/index" element={<Navigate to="/" replace />} />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/mortgage" element={<MortgageProduct />} />
          <Route path="/products/savings" element={<SavingsProduct />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightArticle />} />
          <Route path="/webinars" element={<Webinars />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
